import Lightbox from 'yet-another-react-lightbox';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';

import { CtxMapV2 } from 'components/mapV2/contexts/CtxMapV2';
import React, { useContext } from 'react';
import { useUpdateEffect } from 'usehooks-ts';

interface Props {
    imageUrls: string[];
}

export const useMapV2LightGallery = (props: Props) => {
    const ctxMapV2 = useContext(CtxMapV2);
    const [index, setIndex] = React.useState<number | null>(null);
    const isOpen = index != null;

    useUpdateEffect(() => {
        ctxMapV2.lightGallery.setOpen(isOpen);
    }, [isOpen]);

    const element = (
        <Lightbox
            plugins={props.imageUrls.length > 1 ? [Thumbnails] : []}
            open={isOpen}
            index={index ?? 0}
            close={() => setIndex(null)}
            carousel={{ finite: true }}
            controller={{ closeOnPullDown: true }}
            slides={props.imageUrls.map((src) => ({ src }))}
            thumbnails={{
                border: 0,
                borderRadius: 7
            }}
        />
    );

    return {
        element,
        open: (index: number) => setIndex(index)
    };
};
